import { render, staticRenderFns } from "./_UserInfo.vue?vue&type=template&id=361067ba&scoped=true&"
import script from "./_UserInfo.vue?vue&type=script&lang=js&"
export * from "./_UserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361067ba",
  null
  
)

export default component.exports